import React from 'react'
import { Switch } from 'antd'

const SwitchButton = ({ 
  checked = false, 
  onChange, 
  disabled = false,
  size = 'default',
  className = ''
}) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      size={size}
      className={className}
    />
  )
}

export default SwitchButton